export default __webpack_public_path__ + "static/media/icon_12.fc07be4b.png";